import { render, staticRenderFns } from "./cTabPlashka.vue?vue&type=template&id=6964976f&"
import script from "./cTabPlashka.vue?vue&type=script&lang=ts&"
export * from "./cTabPlashka.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports